<template>
    <div class="contact-us-container">
      <h1>Contact Us</h1><br/>
      
      <form @submit.prevent="handleSubmit" class="contact-form">
        <div class="form-group">
          <label for="name">Your Name</label>
          <input
            v-model="form.name"
            type="text"
            id="name"
            placeholder="Enter your name"
            required
          />
        </div>
  
        <div class="form-group">
          <label for="email">Email Address</label>
          <input
            v-model="form.email"
            type="email"
            id="email"
            placeholder="Enter your email"
            required
          />
        </div>
  
        <div class="form-group">
          <label for="subject">Subject</label>
          <input
            v-model="form.subject"
            type="text"
            id="subject"
            placeholder="Subject of your message"
            required
          />
        </div>
  
        <div class="form-group">
          <label for="message">Message</label>
          <textarea
            v-model="form.message"
            id="message"
            placeholder="Write your message"
            rows="5"
            required
          ></textarea>
        </div>
  
        <button type="submit" class="submit-btn">Send Message</button>
      </form>
  
      <div v-if="isSuccess" class="success-message">
        <p>Thank you for reaching out! We will get back to you soon.</p>
      </div>
  
      <div v-if="isError" class="error-message">
        <p>Oops! Something went wrong. Please try again later.</p>
      </div>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent, ref } from "vue";
   import instance from '@/axios'
  
  export default defineComponent({
    name: "ContactUs",
    setup() {
      const form = ref({
        name: "",
        email: "",
        subject: "",
        message: "",
      });
  
      const isSuccess = ref(false);
      const isError = ref(false);
  
      const handleSubmit = async () => {
        // Simulate a form submission to an endpoint

        await instance.post('/admin/sendMailToAdmin',form.value)
        const mockApiResponse = true; // Assume this is the response from an API
  
        if (mockApiResponse) {
          isSuccess.value = true;
          isError.value = false;
          form.value = { name: "", email: "", subject: "", message: "" }; // Reset form
        } else {
          isError.value = true;
          isSuccess.value = false;
        }
      };
  
      return {
        form,
        isSuccess,
        isError,
        handleSubmit,
      };
    },
  });
  </script>
  
  <style scoped>
  .contact-us-container {
    max-width: 500px;
    margin: 3px auto;
    padding: 0 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  h1 {
    text-align: center;
    color: #4CAF50;
  }
  
  .contact-form {
    display: flex;
    flex-direction: column;
  }
  
  .form-group {
    margin-bottom: 15px;
  }
  
  .form-group label {
    font-weight: bold;
    margin-bottom: 5px;
  }
  
  .form-group input,
  .form-group textarea {
    width: 100%;
    padding: 10px;
    font-size: 14px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }
  
  .form-group textarea {
    resize: vertical;
  }
  
  .submit-btn {
    padding: 10px;
    background-color: #4CAF50;
    color: #fff;
    border: none;
    font-size: 16px;
    cursor: pointer;
    border-radius: 4px;
  }
  
  .submit-btn:hover {
    background-color: #45a049;
  }
  
  .success-message {
    padding: 15px;
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    border-radius: 4px;
    color: #155724;
  }
  
  .error-message {
    padding: 15px;
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    border-radius: 4px;
    color: #721c24;
  }
  </style>
  